import { FieldPath } from 'react-hook-form';

import { RHFTextInput } from 'components/input/RHFTextInput';
import { NormalizedLoad } from 'types/Load';

type LoadBuildingTextInputProps = React.ComponentPropsWithoutRef<
  typeof RHFTextInput
> & { name: FieldPath<NormalizedLoad> };

export const LoadBuildingTextInput = (props: LoadBuildingTextInputProps) => (
  <RHFTextInput {...props} />
);
